import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Layout, Typography, Button, Table, Tag, Badge, Spin, Empty, Space, message, Card, Divider, Modal, Radio, Select, Pagination, Avatar, Drawer } from "antd";
import { UserOutlined, PlusCircleFilled, MinusCircleFilled } from '@ant-design/icons'
import { useMutation } from "react-query";
import '../styles.css'
import api from "../api";
import { utilities } from "../../../utilities/utlities";
import { productsConfig } from '../../../configurations/products'
const ViewRFI = (props) => {
    const { rfqId, id, supplierRfi } = useParams();
    const [user] = useState(utilities.loggedUser())
    const { data, error, isError, isLoading } = api.useSingleRFI(id, user.jwtToken)
    const [showDrawer, setShowDrawer] = useState(false)
    const [inputs, setInputs] = useState([{}])
    const [missingField, setMissingFields] = useState([])
    const [openRFP, setOpenRFP] = useState(false)

    const onClickCloseDrawer = () => {
        setShowDrawer(false)
    }
    const onOpenRFPDrawer = (value) => {
        setOpenRFP(value)
    }
    const mutation = useMutation((data) => {
        return api.acceptRfi(data)
    }, {
        onSuccess: (data) => {
            message.success("Successfully Sent", 3)
        },
        onError: (err) => {
            message.error('Something Went Wrong!', 3)
        }
    })
    const onClickShowDrawer = () => {
        setShowDrawer(true)
    }
    const updateSelectValues = (index, name, val) => {
        const list = [...inputs];
        list[index][name] = val;
        setInputs(list);
    }
    const handleAddInput = () => {
        setInputs([...inputs, { value: "" }]);
    }
    const handleRemoveInput = (index) => {
        const list = [...inputs];
        list.splice(index, 1);
        setInputs(list);
    }
    const { Text, Link: TextLink } = Typography
    const { Content } = Layout
    const { Option } = Select
    return (
        <Layout className="layout">
            <Content style={{ justifyContent: 'flex-start', marginTop: 25 }} className="site-layout-content">
                {isLoading ? <Spin></Spin> :
                    <div style={{ width: '100%' }}>
                        <div style={{ padding: '0 25px 10px' }}>
                            <Text style={{ fontWeight: 500, fontSize: 18 }}>Activity Center</Text>
                            {user?.type != 'supplier' ? <div style={{ justifyContent: 'flex-start', fontSize: 12 }}>
                                <Link to="/rfq" className="link">Manage RFQ</Link>
                                <Text> / </Text>
                                <Link to={`/rfq/${data?.rfi?.rfqId}`}> {data?.rfq?.title}</Link>
                                <Text> / </Text>
                                <Text type='secondary'> {data.rfi.supplier.name}</Text>
                            </div> : null}
                        </div>
                        <Card style={{ width: '100%' }}>
                            <div style={{ padding: '0 5px 10px', display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Text>Supplier: <Text type='secondary'>{data.rfi.supplier.name}</Text></Text>
                                    <Text>Product: <TextLink href="">{data.rfi.productRequired.name + " " + data.rfi.productRequired.strength}</TextLink></Text>
                                </div>
                                {/* {data?.rfi?.supplier?.responseSent ? */}
                                <Space className="rfiAction">
                                    <Button onClick={onClickShowDrawer} type='primary'>Ask for more</Button>
                                    <Button style={{ backgroundColor: '#00FFB9' }} onClick={() => {
                                        onOpenRFPDrawer(true)
                                    }}>Send RFP</Button>
                                </Space>
                                {/* : null}  */}
                            </div>
                            <Divider style={{ position: 'absolute', left: 0 }} className='divider' />
                            <div style={{ padding: '30px 5px 10px' }}>
                                {data.rfi.activity.map((item, index) => {
                                    let date = new Date('12/03/2022 14:32:22')
                                    return (
                                        <div>
                                            {item.by.toString() === user._id.toString() ?
                                                <Avatar size={25} icon={<UserOutlined />}></Avatar> :
                                                <Avatar size={25} className='activityAvatar' icon={<UserOutlined />}></Avatar>

                                            }
                                            <Space style={{ marginLeft: 20 }} direction='vertical'>
                                                <Space>
                                                    <Text>{item.by.toString() === user._id.toString() ? 'Me' : 'Not Me'}</Text>
                                                    <Space>
                                                        <Text type='secondary'>{date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()}</Text>
                                                        <Text type='secondary'>{date.getHours() + ":" + date.getMinutes()}</Text>
                                                    </Space>
                                                </Space>
                                                <Space>
                                                    <Text>{item.description}</Text>
                                                </Space>
                                                {item?.fields.map(item => {
                                                    const filteractivity = productsConfig?.fields?.filter(activity => activity?.name == item)
                                                    if (filteractivity[0]?.name != undefined && data?.rfi?.productDetails?.[filteractivity[0]?.name] != undefined) {
                                                        if (typeof data?.rfi?.productDetails?.[filteractivity[0]?.name] == 'string') {
                                                            return <div className="activityFielddata">
                                                                <Text>{filteractivity[0]?.title}?</Text>

                                                                <Text>{data?.rfi?.productDetails?.[filteractivity[0]?.name]}</Text>
                                                            </div>

                                                        }
                                                    }
                                                    // if(typeof data?.rfi?.productDetails?.[filteractivity[0]?.name] == )
                                                })

                                                }
                                            </Space>
                                            {index < data.rfi.activity.length - 1 ? <Divider /> : null}
                                        </div>
                                    )
                                })}
                            </div>
                        </Card>
                    </div>}
            </Content>
            <Drawer
                size='large'
                title="Ask supplier for more"
                placement='right'
                visible={showDrawer}
                extra={
                    <Space>
                        <Button onClick={onClickCloseDrawer}>Cancel</Button>
                        <Button style={{ backgroundColor: '#00FFB9' }} onClick={() => {
                            mutation.mutateAsync({
                                missingFields: missingField,
                                token: user?.jwtToken,
                                rfiId: id,
                                userTyepe: 'distributor'
                            })

                        }}
                            loading={mutation?.isLoading}
                        >
                            Send
                        </Button>
                    </Space>
                }
                onClose={onClickCloseDrawer}>
                <Space direction='vertical' style={{ width: '100%', marginTop: 20 }}>
                    <Text>Ask for: </Text>
                    {inputs.map((item, index) => {
                        console.log(item)
                        return (
                            <Select
                                style={{ width: '100%' }}
                                className={item.invalid ? 'invalid-select' : ''}
                                name="keys"
                                id={"keys" + index}
                                value={item.value}
                                mode='multiple'
                                onChange={(e) => {
                                    setMissingFields(e)
                                    updateSelectValues(index, 'value', e)
                                }}>
                                {productsConfig.fields.map((val) => {
                                    return (
                                        <Option value={val.key}>{val.title}</Option>
                                    )
                                })}
                            </Select>
                        )
                    })}
                </Space>
            </Drawer>



            {/* RFP SEND DRAWER */}
            <Drawer
                size='large'
                title="Send RFP"
                placement='right'
                visible={openRFP}
                extra={
                    <Space>
                        <Button onClick={() => {
                            onOpenRFPDrawer(false)
                        }}>Cancel</Button>
                        <Button style={{ backgroundColor: '#00FFB9' }} onClick={() => {
                            mutation.mutateAsync({
                                missingFields: missingField,
                                token: user?.jwtToken,
                                rfiId: id,
                                userTyepe: 'distributor'
                            })

                        }}
                            loading={mutation?.isLoading}
                        >
                            Send RFP
                        </Button>
                    </Space>
                }
                onClose={() => {
                    onOpenRFPDrawer(false)
                }}>
            </Drawer>
        </Layout>
    )
}
export default ViewRFI